import type { Resource } from '../../';
export const general_errors_renderAlerts_digest: Resource = {"default":"Digest"};
